import { routes } from '@routes';
import type {
  GetAllSubscriptionPlansPlanResponseDto,
  GetBillingAccountResponseSubscriptionDto,
  PrismaOrganizationDto,
} from 'app/API';
import { useNavigate } from 'react-router';
import { ActiveCard } from '../Cards/ActiveCard';
import { CanceledCard } from '../Cards/CanceledCard';
import { PaymentFailedCard } from '../Cards/PaymentFailedCard';
import { TrialingCard } from '../Cards/TrialingCard';

import { Wrapper } from './styles/Wrapper';

type TProps = {
  subscription: GetBillingAccountResponseSubscriptionDto;
  plan: GetAllSubscriptionPlansPlanResponseDto;
  reloadPage?: () => void;
  managementSource: PrismaOrganizationDto['managementSource'];
};

export const SubscriptionCard = ({ managementSource, subscription, plan, reloadPage }: TProps) => {
  const navigate = useNavigate();

  const openSubscriptionPage = () => {
    navigate(routes.adminAutoScriptOneSubscriptionDetails.make(subscription.id));
  };

  // Todo: we need to do something here. Coz this is not a failed state
  if (subscription.status === 'incomplete' || subscription.status === 'incomplete_expired') {
    return (
      <Wrapper onClick={openSubscriptionPage}>
        <PaymentFailedCard
          managementSource={managementSource}
          reload={reloadPage || (() => {})}
          subscription={subscription}
        />
      </Wrapper>
    );
  }

  if (subscription.status === 'canceled') {
    return (
      <Wrapper onClick={openSubscriptionPage}>
        <CanceledCard plan={plan} />
      </Wrapper>
    );
  }

  if (subscription.status === 'past_due' || subscription.status === 'unpaid') {
    return (
      <Wrapper onClick={openSubscriptionPage}>
        <PaymentFailedCard
          managementSource={managementSource}
          reload={reloadPage || (() => {})}
          subscription={subscription}
        />
      </Wrapper>
    );
  }

  if (subscription.status === 'trialing') {
    return (
      <Wrapper onClick={openSubscriptionPage}>
        <TrialingCard plan={plan} subscription={subscription} reload={reloadPage || (() => {})} />
      </Wrapper>
    );
  }

  // Default is Active
  return (
    <Wrapper onClick={openSubscriptionPage}>
      <ActiveCard plan={plan} subscription={subscription} reload={reloadPage || (() => {})} />
    </Wrapper>
  );
};
